import * as React from 'react';
import TabButton from '../layouts/TabButton';
import { DataItem } from 'src/reducers/dashboard';
import { UserDetail } from 'src/reducers/user';

export interface DashboardPageProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    addNewOrder: () => void;
    addNewFeedback: () => void;
    liveOrder: () => void;
    completedOrder: () => void;
    manuCompletedOrder: () => void;
    filterCompletedOrder: () => void;
    liveOrderCount: string;
    completedOrderCount: string;
    onholdcount: string;
    onreturn: string;
    designready: string;
    greatestvalue: string;
    completedcnt: string;
    chartData: DataItem[];
    goTutorial: () => void;

    userDetails: UserDetail;
}

class DashboardPage extends React.Component<DashboardPageProps> {
    render() {
        return (
            <div>
                <TabButton
                    addNewOrder={this.props.addNewOrder}
                    addNewFeedback={this.props.addNewFeedback}
                    liveOrder={this.props.liveOrder}
                    completedOrder={this.props.completedOrder}
                    manuCompletedOrder={this.props.manuCompletedOrder}
                    filterCompletedOrder={this.props.filterCompletedOrder}
                    liveOrderCount={this.props.liveOrderCount}
                    completedOrderCount={this.props.completedOrderCount}
                    onholdcount={this.props.onholdcount}
                    onreturn={this.props.onreturn}
                    designready={this.props.designready}
                    goTutorial={this.props.goTutorial}
                    userDetails={this.props.userDetails}
                    completedcnt={this.props.completedcnt}
                />
                {/* <DashboardHomePage
                    liveOrderCount={this.props.liveOrderCount}
                    completedOrderCount={this.props.completedOrderCount}
                    onholdcount={this.props.onholdcount}
                    onreturn={this.props.onreturn}
                    chartData={this.props.chartData}
                    greatestvalue={this.props.greatestvalue}
                    userDetails={this.props.userDetails}
                /> */}
            </div>
        );
    }
    componentDidMount() {
        this.props.onComponentDidMount();
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default DashboardPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardPage.tsx